import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const LoadingContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '200px',
  gap: theme.spacing(2),
}));

const LoadingSpinner: React.FC = () => {
  return (
    <LoadingContainer>
      <CircularProgress />
    </LoadingContainer>
  );
};

export default LoadingSpinner;